<template>
    <v-row>
        <v-col cols="12" class="title-label">
            {{ $t('entrance.basic_info') }}
        </v-col>
        <v-col cols="12">
            <kimsa-text-field
                :label="$t('company.name')"
                :placeholder="$t('company.name_placeholder')"
                :rules="rules.name"
                @change="name = $event"
                :value="name"
            />
        </v-col>
        <v-col cols="12">
            <kimsa-combobox
                :label="$t('entrance.country')"
                :placeholder="$t('entrance.country_placeholder')"
                :items="countries"
                @change="country = $event"
                :value="country"
                ref="country"
            />
        </v-col>
        <v-col cols="12">
            <kimsa-text-field
                :label="$t('entrance.phone')"
                :placeholder="$t('entrance.phone_placeholder')"
                :rules="rules.phone"
                @change="phone = $event"
                :value="phone"
                inputMode="tel"
                :prefix="phonePrefix"
                :disabled="!country"
            />
        </v-col>
        <v-col cols="12">
            <kimsa-text-field
                :label="$t('company.address')"
                :placeholder="$t('company.address_placeholder')"
                @change="address = $event"
                :value="address"
            />
        </v-col>
        <v-col cols="12">
            <kimsa-select
                :label="$t('company.type')"
                :height="64"
                :items="typesOptions"
                @change="type = $event"
                ref="type"
                cols="4"
            />
        </v-col>
    </v-row>
</template>

<script>

import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import KimsaSelect from "@/components/common/inputs/KimsaSelect";

import {mapActions, mapState} from 'vuex'
import {debounce} from "@/utils/Common";

export default {
    name: "BasicInfo",
    components: {
        KimsaTextField,
        KimsaCombobox,
        KimsaSelect,
    },
    props: {
        stepperMode: {
            type: Boolean,
            default: false
        }
    },
    data(vm) {
        return {
            name: '',
            country: '',
            phone: '',
            address: '',
            type: '',

            typesOptions: [
                {name: vm.$t('company.types.club'), value: 'club'},
                {name: vm.$t('company.types.gym'), value: 'gym'},
                {name: vm.$t('company.types.institution'), value: 'institution'}
            ]
        }
    },
    computed: {
        ...mapState(['countries']),
        phonePrefix(vm = this) {
            return vm.country?.phoneCode || '+XX'
        },
        form(vm = this) {
            return {
                name: vm.name,
                phone: vm.phone,
                country: vm.country,
                address: vm.address,
                type: vm.type,
            }
        },
        rules(vm = this) {
            return {
                name: [
                    v => !!v || vm.$t('rules.required'),
                    v => v && v.length >= 3 || vm.$t('rules.min_length', {num: '3'})
                ],
                phone: [
                    v => !!v || vm.$t('rules.required'),
                    v => v && v.length >= 8 || vm.$t('rules.min_length', {num: '8'})
                ]
            }
        }
    },
    async mounted() {
        const vm = this
        if (vm.countries.length === 0) await vm.bindCountries()
        vm.loadAccount()
    },
    methods: {
        ...mapActions(['bindCountries']),
        loadAccount() {
            const vm = this
            vm.name = vm.account?.name || ''
            vm.country = vm.account?.country || ''
            vm.phone = vm.account?.phone || ''
            vm.address = vm.account?.address || ''
            vm.type = vm.account?.type || ''
            vm.$refs.type.model = vm.type
        },
        debouncedEmit: debounce(
            function () {
                this.$emit('change', this.form)
            }, 1000),
    },
    watch: {
        account() {
            if (!this.stepperMode) this.loadAccount()
        },
        form() {
            this.debouncedEmit()
        },
    },
}
</script>

<style scoped>

.title-label {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
}

</style>